import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Button from '@nmx/template/dist/componentLibrary/components/Button';

export const ButtonStyled = styled(Button)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      position: relative;
      top: ${mediumUp ? rem(1) : 0};
      margin-top: ${mediumUp ? 0 : rem(12)};
      margin-bottom: 0;
    `;
  }}
`;

export const FormStyledSearchDirectory = styled.form`
    ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding: ${mediumUp ? rem(40) : rem(24)} 0 0;
    `;
  }}
`;
